/**
 * 支付密码 · 前端校验 & 错误码语义（资金 2FA）
 *
 * 后端 binding（handler/user.go、handler/trade.go）为 6-20 位字符串；
 * 产品口径（PRD §7.2）为 6 位数字 → 前端统一收口为「6 位数字」输入，
 * 设置与支付两端共用同一套校验，避免出现“能设不能付”的契约裂缝。
 * 错误码语义对齐 service/payment_2fa.go：2004/2005/2006/2007。
 */

export const PAY_PASSWORD_LENGTH = 6;

/** 6 位数字支付密码 */
export const PAY_PASSWORD_PATTERN = /^\d{6}$/;

/** 校验支付密码输入；通过返回 null，否则返回用户可读错误文案 */
export function validatePayPassword(value: string): string | null {
  if (!value) return '请输入支付密码';
  if (!PAY_PASSWORD_PATTERN.test(value)) return `支付密码需为 ${PAY_PASSWORD_LENGTH} 位数字`;
  return null;
}

/** 后端支付密码错误码 → 前端处理语义 */
export type PaymentErrorKind = 'not_set' | 'required' | 'wrong' | 'locked' | 'other';

export function paymentErrorKind(code: number): PaymentErrorKind {
  switch (code) {
    case 2004:
      return 'not_set';
    case 2005:
      return 'required';
    case 2006:
      return 'wrong';
    case 2007:
      return 'locked';
    default:
      return 'other';
  }
}

/** 后端支付密码错误码 → 用户可读文案（fallback 用于非 2FA 业务错误） */
export function paymentErrorText(code: number, fallback = '支付失败，请稍后重试'): string {
  switch (code) {
    case 2004:
      return '您尚未设置支付密码，请先完成设置后再支付';
    case 2005:
      return '资金操作必须输入支付密码';
    case 2006:
      return '支付密码错误，请重新输入（连续错误 5 次将锁定 15 分钟）';
    case 2007:
      return '支付密码已连续错误被锁定，请稍后重试；若已解锁仍失败请联系平台客服';
    default:
      return fallback;
  }
}
